import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import ScrollToTop from "react-scroll-to-top";

const BackToTopButton = () => {


  return (
    <>
        <div>
      <ScrollToTop />
    </div>
    </>
  );
};

export default BackToTopButton;
